import { RichTextMembership } from "@r-and-a-shared-ui/common-ui";
import { kontentAiDataMapping } from "@r-and-a-shared-ui/core-data-mapping";

import { MEMBERSHIP_MODELS } from "@r-and-a-shared-ui/common-kontent-client";
export default {
  component: ()=>RichTextMembership,
  mapEntryToProps: (entry: MEMBERSHIP_MODELS.RichTextMembership) =>
    kontentAiDataMapping.rich_text_membership(entry),
};